import Axios from "../util/axiosInstance";

export const GetSplitRoles = () => {
    return Axios.get("/api/Role/GetTalentRoleChanges")
}

export const AddSkillForNewRole = (payload) => {
    return Axios.post("/api/Role/AddSkillForNewRole", payload)
}